import Vue from 'vue';

const STORAGE_PREFIX = 'click_once_';

const clickOnce = Vue.directive('clickOnce', {
  bind(el, binding) {
    const {
      key,
      duration = 1000
    } = binding.value || {};

    if (!key) {
      console.warn('[v-click-once] 必须提供 key 参数');
      return;
    }

    const storageKey = `${STORAGE_PREFIX}${key}`;

    // 禁用按钮
    const setDisabled = () => {
      el.setAttribute('disabled', 'disabled');
      el.classList.add('is-disabled');
    };

    // 恢复按钮
    const setEnabled = () => {
      el.removeAttribute('disabled');
      el.classList.remove('is-disabled');
      localStorage.removeItem(storageKey); // 清除记录，允许再次点击
    };

    // 计算剩余禁用时间，并启动恢复定时器
    const scheduleRecover = (timestamp) => {
      if (duration === 0) return; // 永久禁用，不恢复
      const remaining = duration - (Date.now() - timestamp);
      if (remaining > 0) {
        el._clickOnceTimer = setTimeout(() => {
          setEnabled();
        }, remaining);
      } else {
        // 已过期，直接恢复
        setEnabled();
      }
    };

    const checkDisabled = () => {
      const record = localStorage.getItem(storageKey);
      if (!record) return false;
      const { timestamp } = JSON.parse(record);
      if (duration === 0) return true;
      return Date.now() - timestamp < duration;
    };

    // 挂载时检查，刷新后自动恢复禁用 + 启动倒计时
    const record = localStorage.getItem(storageKey);
    if (record) {
      const { timestamp } = JSON.parse(record);
      if (checkDisabled()) {
        setDisabled();
        scheduleRecover(timestamp); // ← 关键：刷新后也能继续倒计时
      } else {
        // 已过期，清除旧记录
        setEnabled();
      }
    }

    const handler = (event) => {
      if (checkDisabled()) {
        event.stopImmediatePropagation();
        event.preventDefault();
        return;
      }

      const timestamp = Date.now();
      localStorage.setItem(storageKey, JSON.stringify({ timestamp, key }));
      setDisabled();
      scheduleRecover(timestamp); // ← 点击后启动倒计时
    };

    el._clickOnceHandler = handler;
    el.addEventListener('click', handler, true);
  },

  unbind(el) {
    if (el._clickOnceHandler) {
      el.removeEventListener('click', el._clickOnceHandler, true);
      delete el._clickOnceHandler;
    }
    if (el._clickOnceTimer) {
      clearTimeout(el._clickOnceTimer);
      delete el._clickOnceTimer;
    }
  }
});

export { clickOnce };
